import { IBasketActionTypes } from '@epicuro-next/data/baskets';
import {
  faBasketShopping,
  faCartXmark,
  faClone,
  faDownload,
  faEnvelope,
  faFileExcel,
  faFilePdf,
  faListTree,
  faShareNodes,
  faStore,
  faTruck,
  faXmark,
} from '@fortawesome/pro-solid-svg-icons';

export const basketActionIconsMap = {
  [IBasketActionTypes.BASKET_MANAGER]: faListTree,
  [IBasketActionTypes.CLEAR_BASKET]: faCartXmark,
  [IBasketActionTypes.COPY_BASKET]: faClone,
  [IBasketActionTypes.CREATE_COMMERCIAL_LIST]: faBasketShopping,
  [IBasketActionTypes.DOWNLOAD_CONTENT_H2]: faDownload,
  [IBasketActionTypes.DOWNLOAD_CONTENT]: faDownload,
  [IBasketActionTypes.DOWNLOAD_PDF_ASYNC]: faFilePdf,
  [IBasketActionTypes.DROP_SHIP]: faTruck,
  [IBasketActionTypes.EDIT_ADDRESSES]: faStore,
  [IBasketActionTypes.EMAIL_BASKET]: faShareNodes,
  [IBasketActionTypes.SEND_PDF_CONFIRMATION]: faEnvelope,
  [IBasketActionTypes.SWITCH_BASKET]: faListTree,
  [IBasketActionTypes.UPLOAD_MDO_BASKET]: faFileExcel,
  [IBasketActionTypes.CLEAR_MANUAL_DISCOUNTS]: faXmark,
};
